export default "/images/afd970792066878d995292f208afc09a.avif";